import React from 'react';
import './listfooter.css'
import Navsheader from './navs-header';
import { useTranslation } from 'react-i18next';


const Listfooter = (props) => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';


    return ( 
        <nav className='list-footerr' dir={direction}>
                <h2 className='title-list-footer'>{props.title}</h2>
                <ul className='list-footer'>
                    <Navsheader title=  {t('Home')}/>
                    <Navsheader title={t('Events')} />
                    <Navsheader title= {t('About')}/>
                    <Navsheader title={t('Book Now')} />
                </ul>
        </nav>
     );
}
 
export default Listfooter;